import { useLocation } from 'react-router-dom';

export function useSearchParams() {
  const { search } = useLocation();

  return new URLSearchParams(search);
}
